<template>
  <!-- 课程预览页 -->
  <div class="preview_box" ref="previewBox">
    <div v-show="state" class="invalid">该页面为预览效果，短期内将会失效</div>
    <div class="preview_top">
      <div class="top_box">
        <img
          :src="$global.imgUrl + previewData.cover"
          class="cover"
          alt=""
        />
        <div>
          <h2 class="title" v-html="previewData.title"></h2>
          <div class="time">
            <span style="margin-right: 38px;">{{ previewData.publisher }}</span>
            <span>发布时间：{{ previewData.createTime.slice(0, 10) }}</span>
          </div>
          <p class="price">{{ previewData.saleType == 0 ? '免费' : '¥'+previewData.salePrice }}</p>
          <div style="margin-top: 30px;">
            <Button class="btn">立即报名</Button>
            <span><img src="@/assets/img/details/courseCollect.png" alt="" class="top_icon"><span class="share">收藏</span></span>
            <span><img src="@/assets/img/details/courseshare.png" alt="" class="top_icon"><span class="share">分享</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="preview_content" v-html="previewData.content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      previewData: {},
      state: true,
    };
  },
  created() {},
  mounted() {
    this.setPreview();
    this.$nextTick(() => {
      this.$root.$el.style.backgroundColor = "#fafafa";
    });
  },
  methods: {
    // 获取预览详情
    async setPreview() {
      const resp = await this.$apis.userServe.articlePreview({
        articleId: this.$route.query.articleId,
      });
      if (resp.resultCode == 200) {
        this.previewData = resp.data.data;
        // this.getAuthor();
        // this.getPublisher();
      } else {
        this.state = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.preview_box {
  .invalid {
    margin: 0 auto 30px;
    text-align: center;
    width: 396px;
    height: 45px;
    line-height: 45px;
    background: #fff;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .preview_top {
    position: absolute;
    left: 0;
    margin-bottom: 20px;
    width: 100%;
    height: 288px;
    background: #ffffff;
    .top_box {
      display: flex;
      margin: 0 auto;
      padding-top: 37px;
      width: 1200px;
      .cover {
        margin-right: 30px;
        width: 380px;
        height: 214px;
      }
      .title {
        font-size: 24px;
        color: #333333;
        line-height: 33px;
      }
      .time {
        margin: 16px 0 20px;
        font-size: 12px;
        color: #666666;
        line-height: 17px;
      }
      .price {
        font-size: 24px;
        color: #FF0000;
        font-weight: 700;
        line-height: 20px;
      }
      .btn {
        margin-right: 30px;
        width: 130px;
        height: 46px;
        background: #0B35C5;
        border-radius: 10px;
        font-size: 16px;
        color: #FFFFFF;
      }
      .share {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        vertical-align: middle;
        cursor: pointer;
      }
      .top_icon {
        margin: 0 3px 0 30px;
        vertical-align: middle;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  }
  .preview_content {
    margin-top: 338px;
    min-height: 300px;
    background: #ffffff;
    border-radius: 10px;
      &::v-deep img {
        max-width: 100%;
      }
  }
}
</style>